export default function Arrow({ className }) {
    return (
        <svg className={className} width={14} height={9} viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M13.6846 0.333077C13.264 -0.111025 12.5821 -0.111025 12.1616 0.333077L7 5.78353L1.83842 0.333078C1.41786 -0.111024 0.735988 -0.111024 0.315423 0.333078C-0.105143 0.77718 -0.105142 1.49721 0.315423 1.94131L7 9L13.6846 1.94131C14.1051 1.49721 14.1051 0.777179 13.6846 0.333077Z" fill="currentColor" />
        </svg>
    );
}
